import axios from "axios";
import {URLAPISUBIDAPDF, URLCARPETADESTINOPDF} from "./Contantes";
export const subirPdfHostingFile = (file) => {


    return new Promise(resolve => {
        console.log('ingreso');

        if (!file) {
            console.log('no file');
            return resolve({ res: true, data: '' });
        }

        if (typeof file === 'string') {
            console.log('es string');
            return resolve({ res: true, data: file });
        } else {
            const formData = new FormData();
            formData.append('pdf', file);

            // ⚠️ ELIMINA EL OBJETO DE HEADERS AQUÍ ⚠️
            axios.post(URLAPISUBIDAPDF, formData)
                .then(response => {
                    console.log(response);
                    return resolve({ res: true, data: URLCARPETADESTINOPDF + response.data.file_path });
                })
                .catch(error => {
                    console.log(error);
                    return resolve({ res: false, data: error.message });
                });
        }
    });
};

